export default "__VITE_ASSET__DjxAQ29E__"